module.exports = __webpack_public_path__ + "img/project-11.af93d12a.png";